module.exports = __webpack_public_path__ + "static/media/tools-eraser.da755931.svg";